export default __webpack_public_path__ + "static/media/640_dummy2016-naeherin01-de.fc52e7ea.png";